import { ref } from 'vue';

export default ref(0);
